import React, { useState, useEffect, useRef, MouseEvent } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Loader2, Play, Video, Users, Award, Camera } from 'lucide-react';
import { FaPlay, FaVideo, FaMusic, FaBriefcase, FaFilm, FaArrowRight } from 'react-icons/fa';
import { cn } from "@/lib/utils";

interface Service {
  name: string;
  description: string;
  icon: React.ReactNode;
  projects: number;
  featured: boolean;
  bgColor: string;
  specialties: string[];
}

const TopicsFeatureCard: React.FC = () => {
  const [services, setServices] = useState<Service[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hoveredService, setHoveredService] = useState<string | null>(null);

  useEffect(() => {
    // Simulating API call to fetch services
    setTimeout(() => {
      setServices([
        { 
          name: 'Tech Demos', 
          description: 'Product demonstrations and software showcases that convert viewers into users',
          icon: <FaVideo className="w-6 h-6" />,
          projects: 15, 
          featured: true,
          bgColor: 'bg-gradient-to-br from-blue-900/30 to-blue-800/20',
          specialties: ['SaaS Products', 'App Demos', 'B2B Software']
        },
        { 
          name: 'Real Estate SF', 
          description: 'Captivating property showcases and neighborhood stories that sell the San Francisco dream',
          icon: <FaVideo className="w-6 h-6" />,
          projects: 12, 
          featured: true,
          bgColor: 'bg-gradient-to-br from-purple-900/30 to-purple-800/20',
          specialties: ['Luxury Homes', 'Neighborhood Tours', 'Property Showcases']
        },
        { 
          name: 'Commercial Work', 
          description: 'Brand storytelling that connects with California culture and values',
          icon: <FaBriefcase className="w-6 h-6" />,
          projects: 22, 
          featured: false,
          bgColor: 'bg-gradient-to-br from-green-900/30 to-green-800/20',
          specialties: ['Lifestyle Brands', 'Startups', 'Local Business']
        },
        { 
          name: 'Documentary', 
          description: 'Long-form storytelling exploring culture, technology, and human connection',
          icon: <FaFilm className="w-6 h-6" />,
          projects: 8, 
          featured: false,
          bgColor: 'bg-gradient-to-br from-orange-900/30 to-orange-800/20',
          specialties: ['Tech Culture', 'Social Issues', 'Urban Life']
        },
        { 
          name: 'Video Podcast Production', 
          description: 'Professional video podcast production that elevates your audio content with engaging visuals',
          icon: <FaVideo className="w-6 h-6" />,
          projects: 18, 
          featured: true,
          bgColor: 'bg-gradient-to-br from-indigo-900/30 to-indigo-800/20',
          specialties: ['Tech Podcasts', 'Business Shows', 'Creative Content', 'Interview Series']
        }
      ]);
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleServiceClick = (serviceName: string) => {
    console.log('Service clicked:', serviceName);
  };

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left; // Get mouse x position within card
    const y = e.clientY - rect.top;  // Get mouse y position within card
    
    card.style.setProperty('--mouse-x', `${x}px`);
    card.style.setProperty('--mouse-y', `${y}px`);
  };

  return (
    <section className="bg-black text-gray-300">
      <div className="max-w-7xl mx-auto">
        {/* Content removed but section maintained for seamless flow */}
      </div>
    </section>
  );
};

export default TopicsFeatureCard;
